import {RiskModel} from "@/services/ModelRisk/RiskModel";

export class SupplierRiskModel {
    sfvVersion = "10"
    etVersion = "11";

    /**
     * @param {number} supplierId
     * @param {number} familyGroupId
     * @param payload
     * @return {Promise<any>}
     */
    async profileVerification(supplierId, familyGroupId, payload) {
        payload["family_group_id"] = familyGroupId;

        let response = await axios.post(
            `${RiskModel.endpoint}/supplier/${supplierId}/profile-verification/${this.getVersion(familyGroupId)}`,
            payload
        )

        return response.data;
    }

    /**
     * @param {number} supplierId
     * @param {number} familyGroupId
     * @return {Promise<any>}
     */
    async findProfileVerification(supplierId, familyGroupId) {
        let response = await axios.get(
            `${RiskModel.endpoint}/supplier/profile-verification/${this.getVersion(familyGroupId)}?supplier_id=${supplierId}&family_group_id=${familyGroupId}`
        )

        return response.data;
    }

    /**
     * @param {number} supplierId
     * @param {Array<number>} familyGroupId
     * @return {Promise<any>}
     */
    async allOfSupplier(supplierId, familyGroupId) {
        let response = await axios.post(`${RiskModel.endpoint}/supplier/${supplierId}/profile-verification/all`, {
            family_groups_id: familyGroupId
        })
        return response.data;
    }

    getVersion(familyGroupId) {
        if(familyGroupId === 1) {
            return this.sfvVersion;
        }
        return this.etVersion;
    }

    /**
     * @param {Number} supplierId
     * @param {Number} familyGroupId
     * @return {Promise<any>}
     */
    async getReportByFamilyGroup(supplierId, familyGroupId) {
        let response = await axios.post(`${RiskModel.endpoint}/supplier/profile-verification/historical/v/${this.getVersion(familyGroupId)}`, {
            family_group_id: familyGroupId,
            supplier_id: supplierId
        })
        return response.data;
    }
}
